export default __webpack_public_path__ + "static/media/viola.77a8d469.png";